const PRODUCTION_API_BASE_URL = "";
const LEGACY_PRODUCTION_API_BASE_URL = "https://mincool-app.fly.dev";
const RUNTIME_CONFIG_PROXY_PATH = "/api/runtime-config";

function isLocalHostname(hostname = "") {
  return hostname === "localhost" || hostname === "127.0.0.1";
}

function hostnameFromUrl(url = "") {
  try {
    return new URL(url).hostname;
  } catch {
    return "";
  }
}

export function resolveApiBaseUrl({ envApiBaseUrl = "", location = null } = {}) {
  const configuredBaseUrl = (envApiBaseUrl || "").trim().replace(/\/+$/, "");
  if (!location) {
    return configuredBaseUrl || "";
  }
  if (configuredBaseUrl && isLocalHostname(hostnameFromUrl(configuredBaseUrl))) {
    return "";
  }
  if (configuredBaseUrl === LEGACY_PRODUCTION_API_BASE_URL) {
    return PRODUCTION_API_BASE_URL;
  }
  if (configuredBaseUrl) {
    return configuredBaseUrl;
  }
  return PRODUCTION_API_BASE_URL;
}

export function resolveRuntimeConfigUrl({ envApiBaseUrl = "", location = null } = {}) {
  return `${resolveApiBaseUrl({ envApiBaseUrl, location })}${RUNTIME_CONFIG_PROXY_PATH}`;
}
